import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ActivityFeed from "../activity/ActivityFeed";

// One workspace's own activity: who joined, whose role changed, which keys
// were made, what was refused. Only this workspace - what happens elsewhere,
// and what bpExperts do across the platform, is not here and can't be
// reached from here.
export default function ActivityTab({ workspace }) {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        What has happened in {workspace.name}, newest first. Nothing here can be changed - it is a record of what happened.
      </Typography>
      <ActivityFeed scope="workspace" workspaceId={workspace.id} />
    </Box>
  );
}
